<template>
    <div class="clearfix main_center">

        <div class="right-content">
            <el-form ref="form" :model="form" label-width="180px" :rules="rules" >
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>进场项目信息</span>
                    </div>
                    <div class="form-content default-content">
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="所属区域：" size="small" prop="regionId">
                                    <el-select v-model="form.regionId" placeholder="请选择所属区域">
                                        <el-option v-for="item in regionOptions"
                                                   :key="item.value"
                                                   :label="item.label"
                                                   :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="招标（采购）项目名称：" size="small" prop="projectName">
                                    <el-input v-model="form.projectName" placeholder="请输入" />
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="招标（采购）人：" size="small" prop="tendererName">
                                    <el-input v-model="form.tendererName" placeholder="请输入" />
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <el-form-item label="招标（采购）项目内容：" size="small" prop="tenderContent">
                                    <el-input type="textarea"
                                              v-model="form.tenderContent"
                                              placeholder="请输入"
                                              :rows="5"
                                              maxlength="500"
                                              show-word-limit
                                    />
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="预算金额：" size="small" prop="budgetAmount">
                                    <el-input v-model="form.budgetAmount"
                                              style="width: 80%"
                                    ></el-input>&nbsp;&nbsp;万元
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="资金来源：" size="small" prop="fundSource">
                                    <el-input v-model="form.fundSource" placeholder="请输入" />
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="是否评定分离：" size="small" prop="isSeparate">
                                    <el-radio-group v-model="form.isSeparate">
                                        <el-radio label="1">是</el-radio>
                                        <el-radio label="0">否</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="是否远程异地：" size="small" prop="isRemote">
                                    <el-radio-group v-model="form.isRemote">
                                        <el-radio label="1">是</el-radio>
                                        <el-radio label="0">否</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="招标（采购）联系人：" size="small" prop="tendererContact">
                                    <el-input v-model="form.tendererContact" placeholder="请输入" />
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="联系方式：" size="small" prop="tendererPhone">
                                    <el-input v-model="form.tendererPhone" placeholder="请输入" />
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="招标（采购）代理联系人：" size="small">
                                    <el-input v-model="form.agentContact" placeholder="请输入" />
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="联系方式：" size="small">
                                    <el-input v-model="form.agentPhone" placeholder="请输入" />
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                </el-card>
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>附件信息</span>
                    </div>
                    <template>
                        <div class="affixDown" v-if="attachmentList.length > 0" style="margin-bottom: 10px">
                            <affixMsg
                                v-for="(item, index) in attachmentList"
                                :item.sync="item"
                                labelWidth="150px"
                                :index="index"
                                :key="index"
                                type=""
                                :showModal="false"
                                :name="item.name">
                            </affixMsg>
                        </div>
                        <p style="text-align: center" v-if="attachmentList.length === 0">暂无附件数据</p>
                    </template>
                </el-card>
                <el-card class="box-card" style="margin-bottom:10px" v-if="auditHisTable && auditHisTable.length > 0">
                    <div slot="header" class="clearfix">
                        <span>工作流</span>
                    </div>
                    <el-table
                        :data="auditHisTable"
                        stripe
                        border
                        style="width: 100%;">
                        <el-table-column
                            type="index"
                            header-align="center"
                            align="center"
                            label="序号"
                            width="80">
                        </el-table-column>
                        <el-table-column
                            prop="taskName"
                            align="left"
                            :show-overflow-tooltip="true"
                            width="200"
                            label="步骤"  >
                        </el-table-column>
                        <el-table-column
                            prop="userName"
                            align="left"
                            :show-overflow-tooltip="true"
                            width="250"
                            label="办理人员"  >
                        </el-table-column>
                        <el-table-column
                            prop="excuteDate"
                            align="center"
                            width="250"
                            label="处理时间">
                        </el-table-column>
                        <el-table-column
                            prop="auditMsg"
                            align="left"
                            :show-overflow-tooltip="true"
                            label="描述/意见"
                        >
                            <template slot-scope="scope">
                                {{ scope.row.auditMsg==="null" ? "请审批" : scope.row.auditMsg }}
                            </template>
                        </el-table-column>
                    </el-table>
                </el-card>

            </el-form>
        </div>
        <div class="left-content">
            <div class="left-navbar">
                <el-button size="small"
                           type="primary"
                           @click="onClickSave"
                           :loading="saveLoading"
                >保存</el-button>
                <el-button size="small"
                           type="primary"
                           @click="onClickSubmit"
                           :loading="submitLoading"
                >提交</el-button>
                <el-button size="small" @click="backBtn">返回</el-button>
            </div>
        </div>

    </div>
</template>

<script>
import {tabsCloseCurrentHandle} from '@/utils/routeTab';
import affixMsg from '@/components/affixMsg';

const validateBudgetAmount = (rule, value, callback) => {
    //整数位不能超过8位，小数位不能超过6位
    if(!/^\d*\.?\d+$|^\d+\.?\d*$/.test(value)) {
        callback(new Error('预算金额只能输入非负数字'))
    }else if (!/^\d{1,8}(\.\d{1,6})?$/.test(value)) {
        callback(new Error('预算金额整数位不能超过8位，小数位不能超过6位'))
    } else {
        callback()
    }
}

export default {
    components: {
        affixMsg
    },
    data() {
        return {
            id: '',
            form: {},
            attachmentList: [],
            regionOptions: [
                { value: 421201, label: '咸宁市本级' },
                { value: 421202, label: '咸安区' },
                { value: 421221, label: '嘉鱼县' },
                { value: 421222, label: '通城县' },
                { value: 421223, label: '崇阳县' },
                { value: 421224, label: '通山县' },
                { value: 421281, label: '赤壁市' },
            ],
            rules: {
                regionId: [
                    { required: true, message: '请选择所属区域', trigger: 'change' },
                ],
                projectName: [
                    { required: true, message: '请输入项目名称', trigger: 'blur' },
                ],
                tendererName: [
                    { required: true, message: '请输入招标（采购）联系人', trigger: 'blur' },
                ],
                tenderContent: [
                    { required: true, message: '请输入招标（采购）内容', trigger: 'blur' },
                ],
                budgetAmount: [
                    { required: true, message: '请输入预算金额', trigger: 'blur' },
                    { validator: validateBudgetAmount, trigger: 'blur' }
                ],
                fundSource: [
                    { required: true, message: '请输入资金来源', trigger: 'blur' },
                ],
                tendererContact: [
                    { required: true, message: '请输入招标（采购）联系人', trigger: 'blur' },
                ],
                tendererPhone: [
                    { required: true, message: '请输入招标（采购）联系人', trigger: 'blur' },
                ],
                agentContact: [
                    { required: true, message: '请输入招标（采购）代理联系人', trigger: 'blur' },
                ],
                agentPhone: [
                    { required: true, message: '请输入招标（采购）代理联系人', trigger: 'blur' },
                ],

            },
            saveLoading: false, //保存loading
            submitLoading: false, //提交loading
            auditHisTable: [], //监督记录表格数据
        }
    },
    mounted() {
        this.id = this.$route.query.id;
        this.requestDetailData();
    },
    methods: {
        //获取详情数据
        requestDetailData() {
            if (!this.id) {
                this.getAttachments()
                return
            }
            this.$http.get(`/projectEntry/get?projectEntryRegisterId=${this.id}`).then(({data}) => {
                if (data.code === '1') {
                    this.form = {...data.data}
                    // 所属区域回显：后端 Long 字段可能以字符串返回，转成数字与下拉项 value 类型保持一致，避免显示区域编码
                    if (this.form.regionId !== null && this.form.regionId !== '' && this.form.regionId !== undefined) {
                        this.form.regionId = Number(this.form.regionId)
                    }
                    this.getAttachments()
                    this.getFlow()
                }
            })
        },
        //获取流程
        getFlow() {
            if(this.form.processinstanceid) {
                this.$http.get(`/workflow/getInfo?processInstanceid=${this.form.processinstanceid}`).then(res => {
                    if (res.data.data.taskId !== '') {
                        this.taskId = res.data.data.taskId;
                        res.data.data.buttons.forEach(item => {
                            if (item.type === 1) {
                                this.processSubmit = true;
                            }
                            if (item.type === 2) {
                                this.filingCBtn = true
                            }
                            if (item.type === 3) {
                                this.backCBtn = true
                            }
                            if (item.type === 10) {
                                this.backCBtn = true
                                this.filingCBtn = true
                            }
                        })
                        this.auditHisTable = res.data.data.auditHistorys || [];
                    }
                })
            }
        },
        //获取附件相关配置
        getAttachments() {
            this.$http.get(`/attachment/getDataByCodeAndEid?categoryCode=yctb_project_att&entityId=0`).then(({ data }) => {
                if (data.code === "1") {
                    let resData = data.data;
                    if (JSON.stringify(resData) !== "{}") {
                        this.attachmentList = resData;
                        if(this.id) {
                            this.attachmentList[0].attFiles = this.form.attachments;
                        }
                    } else {
                        this.attachmentList = [];
                    }
                } else {
                    this.attachmentList = [];
                }
            });
        },
        //保存
        onClickSave() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    for (const item of this.attachmentList) {
                        if (item.required && item.attFiles.length === 0) {
                            this.$message.error('请上传附件数据！')
                            return
                        }
                    }
                    const params = {
                        ...this.form,
                        attachmentVos: this.attachmentList,
                    }
                    this.saveLoading = true;
                    this.$http.post('/projectEntry/saveOrUpdate', params).then(({data}) => {
                        if (data.code === '1') {
                            this.id = data.data.id;
                            this.form.id =  data.data.id;
                            this.$message.success("保存成功！")
                        } else {
                            this.$message.error(data.msg)
                        }
                    }).finally(() => {
                        this.saveLoading = false;
                    })
                }
            })
        },
        onClickSubmit() { //提交
            if (!this.id) {
                this.$message.error('请先保存数据！')
                return
            }
            const params = {
                id: this.id
            }
            this.submitLoading = true;
            this.$http.post('/projectEntry/submitProcess', params).then(({data}) => {
                if (data.code === '1') {
                    this.$message.success('提交成功！')
                    setTimeout(() => {
                        this.backBtn()
                    }, 1000)
                } else {
                    this.$message.error(data.msg)
                }
            }).finally(() => {
                this.submitLoading = false;
            })
        },
        getRowsIndex(index) {
            return index + 1
        },
        backBtn() { //返回
            tabsCloseCurrentHandle();
            this.$router.push({
                name: 'singleWindowServiceProjectList'
            })
            this.$refs.form.resetFields();
        },
    }


}
</script>

<style lang="less" scoped>
.angle_tag {
    margin-right: 10px !important;
}
</style>
